import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardSubtitle, CardTitle, Col, Row } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'
import NewWarehouseForm from './partials/NewWarehouseForm'
import WarehousesTable from './partials/WarehousesTable'

import { getWarehouses } from './services'
import { handleError } from '../../helpers'

export default function WarehousesList() {
	const [warehouses, setWarehouses] = useState(null)
	const [filterType, setFilterType] = useState('name')
	const [filterValue, setFilterValue] = useState('')

	useEffect(() => {
		!warehouses && getWarehouses({
			[`filter[${filterType}]`]: filterValue,
			include: 'appointmentsCount',
			sort: '-created_at',
		})
			.then(res => setWarehouses(res.data.data))
			.catch(error => handleError(error))
	}, [ warehouses, filterType, filterValue ])

	return (
		<React.Fragment>
			<Row>
				<Col md="4">
					<Card>
						<CardBody>
							<CardTitle>Agregar Bodega</CardTitle>
							<CardSubtitle>Crear nuevo registro</CardSubtitle>
							<hr className='mt-10' />
							<NewWarehouseForm reload={() => setWarehouses(null)} />
						</CardBody>
					</Card>
				</Col>
				<Col>
					<ListTopBar 
						title="Gestión de Bodegas"
						subtitle="Listado general de la plataforma"
						filterType={filterType}
						setFilterType={setFilterType}
						filterValue={filterValue}
						setFilterValue={setFilterValue}
						reload={() => setWarehouses(null)}
						options={[
							{ label: 'Buscar por nombre', value: 'name' },
						]}
						className="mb-10"
					/>
					<Card>
						<CardBody>
							<WarehousesTable 
								warehouses={warehouses}
								reload={() => setWarehouses(null)}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}